/* eslint-disable */
import {setCookie,getCookie} from "@/utils/tools";
import Vue from 'vue'
let weChat = {
  getCode:function(appids){
    /**
     * 获取微信code
     */
    let appid = appids;
    let href = window.location.href;
    let redirect_uri = encodeURI(href.split("#")[0]);
    redirect_uri = redirect_uri.replace(/&/g, '%26');
    window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_uri+"&response_type=code&scope=snsapi_userinfo&state=abcdefghigklmnopqrstuvwxyz#wechat_redirect";
  },
  getUrlStr : function(name){
    /**
     * 获取地址栏参数
     */
    let reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)","i");
    if(reg.test(window.location.href)){
      return unescape(RegExp.$2.replace(/\+/g," "))
    }
    return undefined
  },
  /**
    跳转的重定向地址
  * */
  getHref:function(appid,redirect_url){
    window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_url+"&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
  },
  /**
   第三方平台代公众号实现网页授权跳转的重定向地址
   * */
  getHrefNew:function(appid,redirect_url,component_appid, scope){
    // 添加scope参数 
    // 为了不影响之前功能默认snsapi_userinfo 需用户手动点击授权
    // 可传 snsapi_base 静默授权
    if(!scope) {
      scope = 'snsapi_userinfo'
    }
    window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_url+"&response_type=code&scope="+scope+"&state=STATE&component_appid="+ component_appid +"#wechat_redirect";
  },
  /**
   * 通过微信登录
   * **/

}
export default weChat;



// WEBPACK FOOTER //
// ./src/utils/wxAuthorization.js